<m-popup class="m-tooltip"
         :class="{ 'm--is-disabled': disabled,
                   'm--is-mode-definition': isModeDefinition }"
         :class-name="className"
         :close-on-backdrop="true"
         :focus-management="isMqMaxS"
         :open.sync="propOpen"
         :padding="false"
         :background="false"
         :placement="placement"
         :disabled="disabled"
         :preload="true"
         :lazy="false"
         @open="onOpen"
         @close="onClose">
    <m-icon-button v-if="isModeIcon"
                   slot="trigger"
                   class="m-tooltip__icon"
                   :aria-describedby="tooltipId"
                   :icon-name="iconName"
                   :title="title"
                   button-size="22px"
                   :disabled="disabled">
    </m-icon-button>

    <m-link v-else
            class="m-tooltip__link"
            slot="trigger"
            :aria-describedby="tooltipId"
            mode="button"
            :underline="isModeLink"
            :disabled="disabled"
            @click="onClick">
        <slot name="link"></slot>
    </m-link>
    <div class="m-tooltip__body-container"
         :class="{ 'm--is-mode-icon': isModeIcon,
                   'm--is-size-large': isSizeLarge,
                   'm--has-close-button': hasCloseButton }">
        <m-icon-button class="m-tooltip__close-button"
                       v-if="hasCloseButton"
                       @click="close"
                       icon-name="m-svg__close-clear"
                       icon-size="14px"
                       :svg-tile="CloseTitle">
        </m-icon-button>
        <div :id="tooltipId" class="m-tooltip__body" role="tooltip" >
            <slot></slot>
        </div>
    </div>
</m-popup>
